const View = require("presto-ui").baseView;

let __this;

class Presto extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		__this = this;

		this.setIds(['Content','Your_email_address','Subscribe600000000ø','Get_the_latest_Prest']);

		this.style_Forum = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_Group_5 = {
			onClick: this.onClickHome.bind(this)
		}

		this.style_Group7Quickstart = {
			onClick: this.onClickQuickStartFlow.bind(this)
		}

		this.style_ViewcodeGithubmark = {
			onClick: this.onClickViewCodeFlow.bind(this)
		}

		this.style_Group7Quickstarts = {
			onClick: this.onClickQuickStartUI.bind(this)
		}

		this.style_ViewcodeGithubmarks = {
			onClick: this.onClickViewCodeUI.bind(this)
		}

		this.style_Subscribe600000000ø = {
			onClick: this.onClickSubscribe.bind(this),
			width:"150"
		}

		this.style_Your_email_address = {
			onChange: this.onChangeEmail.bind(this)
		}

		this.subscribed = false;
	}

	onChangeEmail(data){
		this.email = data;
	}

	onClickHome(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileHome2"});
		else
			window.__duiShowScreen(null,{screen:"Home2"});
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickQuickStartFlow() {
		window.open("https://juspay.gitbooks.io/presto-guide/content/install.html",'_blank');
	}

	onClickViewCodeFlow() {
		window.open("https://github.com/juspay/purescript-presto",'_blank');
	}

	onClickQuickStartUI() {
		window.open("https://juspay.gitbooks.io/presto-guide/content/presto-ui/",'_blank');
	}

	onClickViewCodeUI() {
		window.open("https://github.com/juspay/presto-ui",'_blank');
	}

	onClickSubscribe() {
		if((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))){
			var xhttp = new XMLHttpRequest();
			xhttp.onreadystatechange = function() {
			  if (this.readyState == 4 && this.status == 200) {
			  	let response = JSON.parse(this.responseText);
			  	if(response.status == "SUCCESS"){
			  		var cmd = __this.cmd({id : __this.idSet.Your_email_address, text: ""});
					Android.runInUI(cmd,null);
					var cmd = __this.cmd({id : __this.idSet.Subscribe600000000ø, text: "Subscribed", color:"#AA000000", clickable:"false"});
					Android.runInUI(cmd,null);
					var cmd = __this.cmd({id : __this.idSet.Get_the_latest_Prest, text: "We will keep you posted."});
					Android.runInUI(cmd,null);
					__this.email = "0";
				}
			  } else if(this.readyState == 4 && this.status == 500){
			  	let response = JSON.parse(this.responseText);
			  	if(response.status == "FAILURE" && response.errorCode == 2){
			  		var cmd = __this.cmd({id : __this.idSet.Get_the_latest_Prest, text: "Sorry, Try Again."});
					Android.runInUI(cmd,null);
				}
			  } else if(this.readyState == 4 && this.status == 400){
			  	let response = JSON.parse(this.responseText);
			  	if(response.status == "FAILURE" && response.errorCode == 1){
			  		var cmd = __this.cmd({id : __this.idSet.Your_email_address, text: ""});
					Android.runInUI(cmd,null);
					var cmd = __this.cmd({id : __this.idSet.Get_the_latest_Prest, text: "This email is already registered."});
					Android.runInUI(cmd,null);
				}
			  }
			};

			xhttp.onloadend = function() {
		    if(xhttp.status != 200) {
		    	var cmd = __this.cmd({id : __this.idSet.Get_the_latest_Prest, text: "Oops, unable to reach our server"});
					Android.runInUI(cmd,null);
		    }
			}


			xhttp.open("GET","/insertEmail?email="+this.email, true);
			xhttp.send();
		} else if( !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) && this.email != "0" ){
			var cmd = __this.cmd({id : __this.idSet.Get_the_latest_Prest, text: "Not a Valid E-mail..."});
			Android.runInUI(cmd,null);
		}
	}

}

module.exports = Presto;



// WEBPACK FOOTER //
// ./controller/pages/Main/Presto.js